import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { textSizes } from 'theme/media'
import { color, IStyles } from '../../../theme'

const deviceSettingsSystemNotificationsStyles: IStyles = {
    title: {
        fontSize: textSizes.normal,
        ...grid.mb_md,
    },
    switchWrapper: {
        display: 'flex',
        marginBottom: 8,
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    hint: {
        color: color.fontDarkMedium,
        marginTop: 8,
    },
}

addStyles(deviceSettingsSystemNotificationsStyles)
export default deviceSettingsSystemNotificationsStyles
